module.exports = __webpack_public_path__ + "img/ad3.3e399664.png";